<template>
    <v-container fluid>
        <v-row class="mt-6 ml-6">
            <h1 v-if="survey_type==1">指派問卷</h1>
            <h1 v-if="survey_type==2">指派子問卷</h1>
        </v-row>
        <!-- {{assign_list}} -->
        <v-row v-for="(row, idx) in assign_list" :key="'doctor_list'+idx" class="mt-6 ml-6">
            <v-col cols="12" sm="12">
                <v-row>
                    <h3 v-if="survey_type==1">{{idx+1}}. 一般問卷</h3>
                    <h3 v-if="survey_type==2">{{idx+1}}. 子問卷</h3>
                    <v-btn v-if="idx!=0" @click="deleted_assign(idx)" class="ml-3" text icon color="error" :disabled="row.status">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-row>
            </v-col>
            
            <v-col cols="12" sm="12">
                <v-text-field v-model="row.title" single-line class="input_400 ml-6" label="請輸入問卷名稱" :disabled="row.status"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12">
                <v-select v-model="row.doctor" :items="doctor_list" item-text="name" item-value="id" placeholder="請選擇醫師" class="input_400 ml-6" outlined :disabled="row.status"></v-select>
            </v-col>
        </v-row>

        <v-row v-if="survey_type==2" class="mt-6 ml-6">
            <v-btn @click="add_doctor" class="ml-3 mt-3" color="primary">新增醫師</v-btn>
        </v-row>

        <v-row class="mt-12 ml-6">
            <h1>自訂結果</h1>
        </v-row>

        <v-row v-for="(row, idx) in interval" :key="'interval'+idx" class="mt-6 ml-6">
            <v-text-field v-model="row.p1" single-line class="input_200 ml-6" outlined :disabled="row.id>0"></v-text-field>
            &nbsp;&nbsp;
            <h1>≤</h1>
            &nbsp;&nbsp;
            <h1>分數</h1>
            &nbsp;&nbsp;
            <h1><</h1>
            &nbsp;&nbsp;
            <v-text-field v-model="row.p2" single-line class="input_200" outlined :disabled="row.id>0"></v-text-field>
            &nbsp;&nbsp;
            <h1 v-if="row.id<0">:</h1>
            &nbsp;&nbsp;
            <v-btn v-if="row.id<0" @click="set_msg(idx, row.msg)" class="ml-3 mt-3" :color="row.msg==''?'primary':'success'">設定訊息</v-btn>
            <h1 v-else>觸發訊息：{{row.msg}}</h1>
            <v-btn v-if="idx>0 && row.id<0" @click="add_interval" text color="error" class="mt-3">
                <v-icon>mdi-delete</v-icon>
            </v-btn>
        </v-row>
        <v-row class="mt-6 ml-6">
            <v-btn @click="add_interval" text color="blue" :disabled="mode==1">
                <v-icon>mdi-plus</v-icon>新增區間
            </v-btn>
        </v-row>
        <v-row class="mt-6 ml-6">
            <v-spacer></v-spacer>
            <v-btn @click="save" color="success">儲存</v-btn>
        </v-row>

        <v-dialog v-model="push_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">傳送訊息
                    <v-spacer/>
                    <v-icon @click="push_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-row>
                        <v-textarea v-model="edit_msg" outlined  label="輸入您要傳送的訊息"></v-textarea>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="msg_submit" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import bus from '../nav/bus'
var host_url = process.env.VUE_APP_HOST_URL

export default {
    data(){
        return {
            assign_list: [
                {title: '', doctor: -1, status: false},
            ],
            interval: [
                {p1: '', p2: '', msg: '', id: -1},
            ],
            push_dialog: false,
            edit_msg: '',
            edit_idx: -1,

            survey_id: -1, 
            survey_type: 1,

            doctor_list: [],
            mother_title: '',

            // 0: 產生問卷來的 1:產生子問卷來的
            mode: 0,
        }
    },
    mounted(){
        let check = 's' in this.$route.query
        if(check == false) {
            bus.$emit('alert', {msg: "操作異常", title: "提示",　check: "我知道了"})
            this.$router.push('/question_overview')
        }

        if('c' in  this.$route.query)
            this.mode = 1

        this.survey_id = this.$route.query.s
        this.get_survey_info()
    },
    methods:{
        deleted_assign(idx){
            this.assign_list.splice(idx, 1)
        },
        get_survey_info(){
            axios.post(host_url+'get_survey_info/', {survey_id: this.survey_id})
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    console.log(tmp)
                    this.mother_title = tmp.survey_title
                    this.doctor_list = tmp.doctor_list
                    this.survey_type = tmp.survey_type
                    this.interval = tmp.interval

                    if(this.mode == 0)
                        this.assign_list[0].title = this.mother_title
                    else{
                        this.assign_list = tmp.already_assign_list
                    }
                    console.log(this.assign_list)
                }
                else{
                    bus.$emit('alert', {msg: '儲存失敗！', title: "提示",　check: "我知道了"})
                }
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },
        add_doctor(){
            this.assign_list.push({name: this.mother_title, doctor: -1, status: false})
        },
        add_interval(){
            this.interval.push({id: (this.interval.length+1)*-1,
                                p1: '', 
                                p2: '', 
                                msg: ''})
        },
        set_msg(idx, msg){
            this.edit_idx = idx
            this.edit_msg = msg
            this.push_dialog = true
        },
        msg_submit(){
            this.interval[this.edit_idx].msg = this.edit_msg
            this.push_dialog = false
        },
        check_data(post_data){
            let msg = ""
            let all_assign_doctor = []
            // 重複指定醫生
            for(let a of post_data.assign_list){
                if(all_assign_doctor.indexOf(a.doctor) == -1){
                    all_assign_doctor.push(a.doctor)
                }
                else{
                    msg += "不可重複指定同一個醫生！\n"
                    return msg
                }
            }
            // 醫生欄位資料確認
            for(let idx1 in post_data.assign_list){
                let num1 = Number(idx1)+1
                if(post_data.assign_list[idx1].title==""){
                    msg += "新增第"+num1+"位指定醫師尚未填寫問卷名稱！\n"
                }
                if(post_data.assign_list[idx1].doctor==-1){
                    msg += "新增第"+num1+"位指定醫師尚未選擇醫師！\n"
                }
            }
            // 區間上下限確認
            for(let idx1 in post_data.interval){
                let num1 = Number(idx1)+1
                if(String(post_data.interval[idx1].p1)==""){
                    msg += "新增第"+num1+"區間尚未填下限！\n"
                }              
                if(String(post_data.interval[idx1].p2)==""){
                    msg += "新增第"+num1+"區間尚未填上限！\n"
                }   
                if(isNaN(Number(post_data.interval[idx1].p1)) == true || 
                   isNaN(Number(post_data.interval[idx1].p2)) == true ||
                   Number(post_data.interval[idx1].p1)>Number(post_data.interval[idx1].p2)){
                    msg += "新增第"+num1+"區間尚上下限值異常 提醒您只能填數字並且上限值必須大於下限！\n"
                }
                if(post_data.interval[idx1].msg==""){
                    msg += "新增第"+num1+"區間尚未填填寫訊息內容！\n"
                }   
            }
            return msg
        },
        save(){
            if(this.interval.length ==0 ){
                bus.$emit('alert', {msg: '自訂結果尚未設定喔！', title: "提示",　check: "我知道了"})
                return 
            }
            let post_data = {survey_id: this.survey_id, assign_list: this.assign_list, interval: this.interval}
            let msg = this.check_data(post_data)
            if(msg != "")
            {
                bus.$emit('alert', {msg: msg, title: "提示",　check: "我知道了"})
                return 
            }
            axios.post(host_url+'assign_doctor/', post_data)
            .then(response => {
                var tmp = response.data
                if(tmp.status == true){
                    bus.$emit('alert', {msg: '儲存成功！', title: "提示",　check: "我知道了"})
                    this.$router.push('/question_overview')
                }
                else
                    bus.$emit('alert', {msg: '儲存失敗！', title: "提示",　check: "我知道了"})
            })
            .catch((error)=> {
                console.log(error);
            }); 
        },
    }
}
</script>

<style lang="scss" scoped>

::v-deep .input_200{
    max-width: 200px;
}

::v-deep .input_400{
    max-width: 400px;
}

</style>